import { render, staticRenderFns } from "./MediationView.vue?vue&type=template&id=2078ef87&"
import script from "./MediationView.vue?vue&type=script&lang=js&"
export * from "./MediationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports